import { Link } from "react-router-dom";
import Icon from "./Icon";
import { IMPORT_STEPS } from "../content/site";
import s from "./ProcessSteps.module.css";

/**
 * The four import steps. Every card starts the request form: with `onSelect`
 * (inside the wizard) it calls it, otherwise it links to /dovoz and opens step 1.
 */
export default function ProcessSteps({ onSelect }) {
  return (
    <ol className={s.steps}>
      {IMPORT_STEPS.map((step, i) => {
        const content = (
          <>
            <div className={s.head}>
              <span className={s.num}>{String(i + 1).padStart(2, "0")}</span>
              <Icon name={step.icon} size={22} />
            </div>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
            <span className={s.cta} aria-hidden="true">Začít poptávku <Icon name="arrow-right" size={16} /></span>
          </>
        );
        return (
          <li key={step.title} className={s.step}>
            {onSelect
              ? <button type="button" className={s.link} onClick={onSelect}>{content}</button>
              : <Link to="/dovoz" state={{ start: true }} className={s.link}>{content}</Link>}
          </li>
        );
      })}
    </ol>
  );
}
